import type { ReactElement } from 'react';
import { SponsoredEditor, SponsoredList } from './Sponsored.tsx';

/** `g g` cannot work (the second g restarts the prefix), so the area takes the free letter b ("brand videos"). */
export const SPONSORED_SHORTCUTS: [string, string][] = [
  ['g then b', 'Go to Sponsored exclusives (brand videos)'],
  ['n', 'New sponsored exclusive (on the list)'],
];

export function sponsoredPage(path: string): ReactElement | null {
  if (path === '/sponsored') return <SponsoredList />;
  if (path === '/sponsored/new') return <SponsoredEditor campaignRef={null} />;
  const match = /^\/sponsored\/(spc_[A-Za-z0-9]+)$/.exec(path);
  return match ? <SponsoredEditor campaignRef={match[1]!} /> : null;
}
